import { render, staticRenderFns } from "./NoteListTagsFilter.vue?vue&type=template&id=801899f0&"
import script from "./NoteListTagsFilter.vue?vue&type=script&lang=js&"
export * from "./NoteListTagsFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports